
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { customersApi } from '@/apis';
import OsDatatable from '@/components/core/OsDatatable.vue';
import { IReportContentCategory, ReportAudience } from '@/models/application';
import OsCard from '@/components/core/card/OsCard.vue';
import OsCardText from '@/components/core/card/OsCardText.vue';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import OsToolbar from '@/components/core/OsToolbar.vue';
import OsRecipientForm from '@/components/shared/recipients/OsRecipientForm.vue';
import OsCloseButton from '@/components/core/OsCloseButton.vue';
import OsInputLookup from '@/components/core/input/OsInputLookup.vue';
import OsInputSelect from '@/components/core/input/OsInputSelect.vue';
import OsButton from '@/components/core/OsButton.vue';
import OsInputCheckboxGroup from '@/components/core/input/OsInputCheckboxGroup.vue';

@Component({
  components: {
    OsInputCheckboxGroup,
    OsButton,
    OsInputSelect,
    OsInputLookup,
    OsCloseButton,
    OsRecipientForm,
    OsToolbar,
    OsSheetContent,
    OsSheet,
    OsCardText,
    OsCard,
    OsDatatable
  }
})
export default class OsAssignedReportCategoriesCheckboxView extends Vue {
  @Prop({ default: 'Selected report segments' })
  textHeader!: string;

  @Prop({ required: false, default: false })
  readonly!: string;

  @Prop({ default: null, required: true })
  customerId!: string;

  @Prop({ default: null, required: true })
  campaignId!: string;

  @Prop({ default: null, required: true })
  audience!: ReportAudience;

  possibleReportCategories: IReportContentCategory[] = [];
  assignedReportCategories: IReportContentCategory[] = [];

  checkBoxItems: { id: string; label: string; isSelected: boolean }[] = [];

  get addedCategories(): IReportContentCategory[] {
    const selectedIds = this.checkBoxItems
      .filter((ci) => ci.isSelected)
      .map((ci) => ci.id);
    const newSelectedIds = selectedIds.filter(
      (si) => !this.assignedReportCategories.find((arc) => arc.id === si)
    );
    return this.possibleReportCategories.filter((prc) =>
      newSelectedIds.find((id) => prc.id === id)
    );
  }

  get removedCategories(): IReportContentCategory[] {
    const unselectedIds = this.checkBoxItems
      .filter((ci) => !ci.isSelected)
      .map((ci) => ci.id);
    const selectedIdsToRemove = unselectedIds.filter((si) =>
      this.assignedReportCategories.find((arc) => arc.id === si)
    );
    return this.possibleReportCategories.filter((prc) =>
      selectedIdsToRemove.find((id) => prc.id === id)
    );
  }

  @Watch('checkBoxItems', { deep: true })
  onCheckBoxItemsChanged() {
    this.$emit('update:removedCategories', this.removedCategories);
    this.$emit('update:addedCategories', this.addedCategories);
  }

  async mounted() {
    await this.reloadAssignedCategories();
  }

  async reloadAssignedCategories() {
    this.possibleReportCategories =
      await customersApi.getAssignedReportContentCategories(
        this.customerId,
        this.audience
      );
    this.assignedReportCategories =
      await customersApi.getAssignedReportContentForCampaignCategories(
        this.customerId,
        this.audience,
        this.campaignId
      );

    this.buildCheckBoxItemsFromProps();
  }

  buildCheckBoxItemsFromProps() {
    this.checkBoxItems = this.possibleReportCategories.map((prc) => {
      return {
        id: prc.id,
        label: prc.name,
        isSelected: !!this.assignedReportCategories.find(
          (arc) => arc.id === prc.id
        )
      };
    });
  }
}
